import React, { FC, ReactNode } from 'react';
import { useTranslate } from '@refinedev/core';
import { SaveOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { Button } from 'components/ui/button';
import styles from './StepNavigation.module.scss';

interface StepNavigationProps {
    currentStep: number;
    totalSteps?: number;
    onPrevious: () => void;
    onNext: () => void;
    onSave: () => void;
    sendDec?: () => void;
    isProcessing?: boolean;
    disabled?: boolean;
    disSubmit?: boolean;
    showSaveButton?: boolean;
    extraActions?: ReactNode;
    showSubmitButton?: boolean;
    confirmSendDec?: boolean;
}

export const StepNavigation: FC<StepNavigationProps> = ({
    currentStep,
    totalSteps = 5,
    onPrevious,
    onNext,
    onSave,
    sendDec,
    isProcessing = false,
    disabled = false,
    disSubmit = false,
    showSaveButton = true,
    extraActions,
    showSubmitButton = true,
    confirmSendDec = false,
}) => {
    const t = useTranslate();

    const isActionDisabled = isProcessing || disabled;
    const isFirstStep = currentStep === 0;
    const isLastStep = currentStep === totalSteps - 1;
    const renderSaveButton = showSaveButton && currentStep >= 3; // Show save on Steps 4 & 5 (indices 3 & 4)

    return (
        <div className={styles.navigationContainer}>
            <div className={styles.leftActions}>
                {!isFirstStep && (
                    <Button
                        onClick={onPrevious}
                        variant="secondary"
                        disabled={isActionDisabled}
                    >
                        {t('buttons.back', 'Назад')}
                    </Button>
                )}

                {!isLastStep && (
                    <Button
                        onClick={onNext}
                        variant="primary"
                        disabled={isActionDisabled}
                    >
                        {t('buttons.next', 'Далі')}
                    </Button>
                )}

                {renderSaveButton && (
                    <Button
                        onClick={onSave}
                        variant="secondary"
                        disabled={isActionDisabled || disSubmit}
                    >
                        <SaveOutlined /> {t('buttons.save', 'Зберегти')}
                    </Button>
                )}
                {extraActions}

                {showSubmitButton &&
                    sendDec &&
                    isLastStep &&
                    (confirmSendDec ? (
                        <Popconfirm
                            title={t('are_you_sure', 'Ви впевнені?')}
                            onConfirm={sendDec}
                            okText={t('yes', 'Так')}
                            cancelText={t('no', 'Ні')}
                            placement="top"
                            disabled={isActionDisabled || disSubmit}
                        >
                            <Button
                                variant="primary"
                                disabled={isActionDisabled || disSubmit}
                                htmlType="button"
                            >
                                {t(
                                    'preliminary-applications.submit_to_window',
                                    'Передати для перевірки в Єдине вікно'
                                )}
                            </Button>
                        </Popconfirm>
                    ) : (
                        <Button
                            variant="primary"
                            disabled={isActionDisabled || disSubmit}
                            htmlType="button"
                        >
                            {t(
                                'preliminary-applications.submit_to_window',
                                'Передати для перевірки в Єдине вікно'
                            )}
                        </Button>
                    ))}
            </div>
        </div>
    );
};
